/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Achievement_Sessions_100_HintInputs */

const en_us2_achievement_sessions_100_hint = /** @type {(inputs: Achievement_Sessions_100_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`100 workouts done`)
};

const pt_br2_achievement_sessions_100_hint = /** @type {(inputs: Achievement_Sessions_100_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`100 treinos feitos`)
};

const es_419_achievement_sessions_100_hint = /** @type {(inputs: Achievement_Sessions_100_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`100 entrenamientos hechos`)
};

const pt_pt2_achievement_sessions_100_hint = /** @type {(inputs: Achievement_Sessions_100_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`100 treinos feitos`)
};

const fr_fr2_achievement_sessions_100_hint = /** @type {(inputs: Achievement_Sessions_100_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`100 séances faites`)
};

const de_de2_achievement_sessions_100_hint = /** @type {(inputs: Achievement_Sessions_100_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`100 Trainings absolviert`)
};

const it_it2_achievement_sessions_100_hint = /** @type {(inputs: Achievement_Sessions_100_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`100 allenamenti fatti`)
};

/**
* | output |
* | --- |
* | "100 workouts done" |
*
* @param {Achievement_Sessions_100_HintInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const achievement_sessions_100_hint = /** @type {((inputs?: Achievement_Sessions_100_HintInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Achievement_Sessions_100_HintInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_achievement_sessions_100_hint(inputs)
	if (locale === "es-419") return es_419_achievement_sessions_100_hint(inputs)
	if (locale === "pt-PT") return pt_pt2_achievement_sessions_100_hint(inputs)
	if (locale === "fr-FR") return fr_fr2_achievement_sessions_100_hint(inputs)
	if (locale === "de-DE") return de_de2_achievement_sessions_100_hint(inputs)
	if (locale === "it-IT") return it_it2_achievement_sessions_100_hint(inputs)
	return en_us2_achievement_sessions_100_hint(inputs)
});
export { achievement_sessions_100_hint as "achievement.sessions_100_hint" }